import { Image } from '@models/Image'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { MEMBERSHIP_DEMO_TAB_PHOTO_URL } from '@utils/urls'

interface DemoTabPhoto {
  /** `null` until a photo is saved: the app then shows its bundled one. */
  photo: Image | null
}

const fetchDemoTabPhoto = () =>
  SBAPI.Fetch<DemoTabPhoto>(MEMBERSHIP_DEMO_TAB_PHOTO_URL)

/** Replace the demo tab photo. There is no way to remove it, only to replace it. */
const updateDemoTabPhoto = (file: File) => {
  const data = new FormData()
  data.append('file', file)
  return SBAPI.Post(MEMBERSHIP_DEMO_TAB_PHOTO_URL, data)
}

export { fetchDemoTabPhoto, updateDemoTabPhoto }
export type { DemoTabPhoto }
